import { render, staticRenderFns } from "./DataCell.vue?vue&type=template&id=1902838e&lang=pug"
import script from "./DataCell.vue?vue&type=script&lang=js"
export * from "./DataCell.vue?vue&type=script&lang=js"
import style0 from "./DataCell.vue?vue&type=style&index=0&id=1902838e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports